export const data = [
  {
    title: "Banana Republic Blue Jacket",
    price: 15,
    category: "jacket",
    image:
      "https://images.unsplash.com/photo-1542329799-fa08b82df09c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
  },

  {
    price: 22,
    title: "Uniqlo Gray Jacket",
    category: "jacket",
    image:
      "https://images.unsplash.com/photo-1507114845806-0347f6150324?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
  },

  {
    price: 22,
    title: "Force Majure Montreal White Shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1508427953056-b00b8d78ebf5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80",
  },
  {
    price: 28,
    title: "Banana Republic White T-shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1556217477-d325251ece38?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=962&q=80",
  },
  {
    price: 24,
    title: "Hanes White T-shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1553754538-466add009c05?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1495&q=80",
  },

  {
    price: 28,
    title: "Addidas Black Cap",
    category: "hat",
    image:
      "https://images.unsplash.com/photo-1494883759339-0b042055a4ee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1567&q=80",
  },

  {
    price: 28,
    title: "Hanes Mens Grey T-shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1552642986-ccb41e7059e7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
  },

  {
    price: 20,
    title: "JCrew Mens Black Pants",
    category: "pants",
    image:
      "https://images.unsplash.com/photo-1572708609022-9689cecb4218?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
  },
  {
    price: 24,
    title: "Urban Outfitters Black Pants",
    category: "pants",
    image:
      "https://images.unsplash.com/photo-1466547599693-252e6f5f30b0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1060&q=80",
  },
  {
    price: 24,
    title: "Everlane Black T-shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1553983712-12df6688a7b6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
  },

  {
    price: 23,
    title: "Osiris Unisex T-Shirt",
    image:
      "https://images.unsplash.com/photo-1520975439795-26ee45a11903?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2695&q=80",
  },
  {
    price: 22,
    title: "Osiris Denim Cap",
    category: "hat",
    image:
      "https://images.unsplash.com/photo-1565285602696-9e9580111011?ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80",
  },
  {
    price: 28,
    title: "Bonobos Mens Black T-Shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1543501527-cf6611f77938?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80",
  },

  {
    price: 22,
    title: "Uniqlo Unisex Grey T-Shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1558471952-13cf349a1cc4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
  },
  {
    price: 28,
    title: "Addidas Unisex White Graphic T-Shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1568563680125-9a2093380e02?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1567&q=80",
  },
  {
    price: 28,
    title: "Hanes Mens Black Pants",
    category: "pants",
    image:
      "https://images.unsplash.com/photo-1566360293735-094226a5df91?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
  },

  {
    price: 22,
    title: "Orange Hardly Unisex T-shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1565128354282-a6390fc125b2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
  },
  {
    price: 22,
    title: "Spencer's Skeleton Graphic T-shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1503341338985-c0477be52513?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80",
  },
  {
    price: 18,
    title: "APC Mens Black Jacket",
    category: "jacket",
    image:
      "https://images.unsplash.com/photo-1536243298747-ea8874136d64?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
  },
  {
    price: 28,
    title: "Oriental Mens Graphic T-shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1517070208541-6ddc4d3efbcb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
  },
  {
    price: 28,
    title: "Uniqlo Red and Black Striped Dice T-shirt",
    category: "tshirt",
    image:
      "https://images.unsplash.com/photo-1484517186945-df8151a1a871?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=987&q=80",
  },
  {
    price: 200,
    title: "Louis Vuitton Belt",
    image:
      "https://images.unsplash.com/photo-1497361727480-725cf2c9427d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
    category: "belt",
  },
  {
    price: 599,
    title: "Kanye Black Tee",
    image:
      "https://images.unsplash.com/photo-1502389614483-e475fc34407e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
    category: "tshirt",
  },
  {
    price: 28,
    title: "Anson Mens Black Belt",
    image:
      "https://images.unsplash.com/photo-1568749750364-053fd74b4115?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80",
    category: "belt",
  },

  {
    price: 16,
    title: "Black Graphic Cap",
    image:
      "https://images.unsplash.com/photo-1468606069560-ce4e8c1b1fe9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1652&q=80",
    category: "hat",
  },
  {
    price: 28,
    title: "Carbon Fiber Cap",
    image:
      "https://images.unsplash.com/photo-1500964935344-6219dea133e4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1001&q=80",
    category: "hat",
  },
  {
    price: 18,
    title: "Grace Chapel Cap",
    image:
      "https://images.unsplash.com/photo-1523380744952-b7e00e6e2ffa?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80",
    category: "hat",
  },

  {
    price: 13,
    title: "Palm Tree Cap",
    image:
      "https://images.unsplash.com/photo-1534215754734-18e55d13e346?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=696&q=80",
    category: "hat",
  },

  {
    price: 22,
    title: "Givenchy Paris Mens Black Long Sleeves Shirt",
    image:
      "https://images.unsplash.com/photo-1505632958218-4f23394784a6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80",
    category: "tshirt",
  },
  {
    price: 22,
    title: "Burberry Mens Black Jacket",
    image:
      "https://images.unsplash.com/photo-1490551632573-78c6c247f5d3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
    category: "jacket",
  },
  {
    price: 28,
    title: "Belstaff Brown Fluffy Jacket",
    image:
      "https://images.unsplash.com/photo-1583431339815-df9893d78b38?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2921&q=80",
    category: "jacket",
  },
  {
    price: 28,
    title: "Uniqlo Unisex Checked Pants",
    image:
      "https://images.unsplash.com/photo-1583690297711-7b76731f9c6e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
    category: "pants",
  },
  {
    price: 26,
    title: "Harem Jacked Pants",
    image:
      "https://images.unsplash.com/photo-1572965841528-54da2f2461d9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
    category: "pants",
  },
  {
    price: 28,
    title: "Chief Smoke Mens Red Jacket",
    image:
      "https://images.unsplash.com/photo-1552573102-2b44b44d85b5?ixlib=rb-1.2.1&auto=format&fit=crop&w=2734&q=80",
    category: "jacket",
  },
  {
    price: 24,
    title: "NorthFace Brown Swayed Jacket",
    image:
      "https://images.unsplash.com/photo-1556487697-37357ac9c309?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
    category: "jacket",
  },
  {
    price: 28,
    title: "Brown Business Jacket",
    image:
      "https://images.unsplash.com/photo-1559582798-678dfc71ccd8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80",
    category: "jacket",
  },
  {
    price: 28,
    title: "Antidoto White T-Shirt",
    image:
      "https://images.unsplash.com/photo-1553231208-811608243e3f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=976&q=80",
    category: "tshirt",
  },

  {
    price: 28,
    title: "BLVK Mens Black Shorts",
    image:
      "https://images.unsplash.com/photo-1572980379456-86efa935c95e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
    category: "pants",
  },
  {
    price: 28,
    title: "APC Mens White Jacket ",
    image:
      "https://images.unsplash.com/photo-1539572511325-71494a030b12?ixlib=rb-1.2.1&auto=format&fit=crop&w=668&q=80",
    category: "jacket",
  },
  {
    price: 38,
    title: "FLEX 500",
    category: "shoes",
    image:
      "https://images.unsplash.com/photo-1460353581641-37baddab0fa2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1651&q=80",
  },
  {
    price: 38,
    title: "PURP FUTURES",
    category: "shoes",
    image:
      "https://images.unsplash.com/photo-1510999391231-49f42bcbeec2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80",
  },
  {
    price: 38,
    title: "AIR_CS2 PRIMEKNIT",
    category: "shoes",
    image:
      "https://images.unsplash.com/photo-1536520807309-1f7bae9f8be5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80",
  },
  {
    price: 38,
    title: "DRO BALLERS",
    category: "shoes",
    image:
      "https://images.unsplash.com/photo-1529810313688-44ea1c2d81d3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1153&q=80",
  },
  {
    price: 38,
    title: "CALIFORNIA 78",
    category: "shoes",
    image:
      "https://images.unsplash.com/photo-1516478177764-9fe5bd7e9717?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80",
  },
  {
    price: 38,
    title: "JORDAN 940s",
    category: "shoes",
    image:
      "https://images.unsplash.com/photo-1518527399940-f3f768f47dd2?ixlib=rb-1.2.1&auto=format&fit=crop&w=1652&q=80",
  },
];

export const categories = [
  {
    title: "Shirts",
    category: "tshirt",
    width: "30%",
    image:
      "https://images.unsplash.com/photo-1511746315387-c4a76990fdce?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80",
  },
  {
    title: "Pants",
    height: "100%",
    category: "pants",
    image:
      "https://images.unsplash.com/photo-1556803471-c9eb6d50eb1e?ixlib=rb-1.2.1&auto=format&fit=crop&w=668&q=80",
  },
  {
    title: "Shoes",
    category: "shoes",
    image:
      "https://images.unsplash.com/photo-1558191053-c03db2757e3d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80",
  },
  {
    title: "Jackets",
    category: "jacket",
    image:
      "https://images.unsplash.com/photo-1495105787522-5334e3ffa0ef?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80",
  },
  {
    title: "Hats",
    category: "hat",
    image:
      "https://images.unsplash.com/photo-1575428652377-a2d80e2277fc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80",
  },
];
